/**
 * @generated SignedSource<<29d1f3e904d10846a85e9195b2fc9ec0>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SplitDetailsModal_address$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SplitDetailsContent_address">;
  readonly " $fragmentType": "SplitDetailsModal_address";
};
export type SplitDetailsModal_address$key = {
  readonly " $data"?: SplitDetailsModal_address$data;
  readonly " $fragmentSpreads": FragmentRefs<"SplitDetailsModal_address">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SplitDetailsModal_address",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SplitDetailsContent_address"
    }
  ],
  "type": "EthereumAddressType",
  "abstractKey": null
};

(node as any).hash = "f855836f29988a63dc3d7f82e1f43b32";

export default node;
